export default {
  KEYWORDS: 'keywords',
  BRANDS: 'brands',
  CONTENT: 'content',
  PRODUCTS: 'products'
};
